// VIEW LOB:
export const GET_SU_LOB_START = "GET_SU_LOB_START"
export const GET_SU_LOB_SUCCESS = "GET_SU_LOB_SUCCESS"
export const GET_SU_LOB_FAILED = "GET_SU_LOB_FAILED"
export const GET_SU_LOB_RESET = "GET_SU_LOB_RESET"


// CREATE LOB
export const CREATE_SU_LOB_START = "CREATE_SU_LOB_START"
export const CREATE_SU_LOB_SUCCESS = "CREATE_SU_LOB_SUCCESS"
export const CREATE_SU_LOB_FAILED = "CREATE_SU_LOB_FAILED"
export const CREATE_SU_LOB_RESET = "CREATE_SU_LOB_RESET"

// UPDATE LOB
export const UPDATE_SU_LOB_START = "UPDATE_SU_LOB_START"
export const UPDATE_SU_LOB_SUCCESS = "UPDATE_SU_LOB_SUCCESS"
export const UPDATE_SU_LOB_FAILED = "UPDATE_SU_LOB_FAILED"
export const UPDATE_SU_LOB_RESET = "UPDATE_SU_LOB_RESET"


// DELETE
export const DEL_SU_LOB_START = "DEL_SU_LOB_START"
export const DEL_SU_LOB_SUCCESS = "DEL_SU_LOB_SUCCESS"
export const DEL_SU_LOB_FAILED = "DEL_SU_LOB_FAILED"
export const DEL_SU_LOB_RESET = "DEL_SU_LOB_RESET"



// CONSTANTS FOR SUB LOB =>
    // VIEW SUB LOB:
export const GET_SU_SUB_LOB_START = "GET_SU_SUB_LOB_START"
export const GET_SU_SUB_LOB_SUCCESS = "GET_SU_SUB_LOB_SUCCESS"
export const GET_SU_SUB_LOB_FAILED = "GET_SU_SUB_LOB_FAILED"
export const GET_SU_SUB_LOB_RESET = "GET_SU_SUB_LOB_RESET"


// CREATE SUB LOB
export const CREATE_SU_SUB_LOB_START = "CREATE_SU_SUB_LOB_START"
export const CREATE_SU_SUB_LOB_SUCCESS = "CREATE_SU_SUB_LOB_SUCCESS"
export const CREATE_SU_SUB_LOB_FAILED = "CREATE_SU_SUB_LOB_FAILED"
export const CREATE_SU_SUB_LOB_RESET = "CREATE_SU_SUB_LOB_RESET"

// UPDATE LOB
export const UPDATE_SU_SUB_LOB_START = "UPDATE_SU_SUB_LOB_START"
export const UPDATE_SU_SUB_LOB_SUCCESS = "UPDATE_SU_SUB_LOB_SUCCESS"
export const UPDATE_SU_SUB_LOB_FAILED = "UPDATE_SU_SUB_LOB_FAILED"
export const UPDATE_SU_SUB_LOB_RESET = "UPDATE_SU_SUB_LOB_RESET"


// DELETE
export const DEL_SU_SUB_LOB_START = "DEL_SU_SUB_LOB_START"
export const DEL_SU_SUB_LOB_SUCCESS = "DEL_SU_SUB_LOB_SUCCESS"
export const DEL_SU_SUB_LOB_FAILED = "DEL_SU_SUB_LOB_FAILED"
export const DEL_SU_SUB_LOB_RESET = "DEL_SU_SUB_LOB_RESET"



// INSURANCE COMPANY :
// VIEW INSURANCE COMPANY:
export const GET_INSURANCE_COMPANY_START = "GET_INSURANCE_COMPANY_START"
export const GET_INSURANCE_COMPANY_SUCCESS = "GET_INSURANCE_COMPANY_SUCCESS"
export const GET_INSURANCE_COMPANY_FAILED = "GET_INSURANCE_COMPANY_FAILED"
export const GET_INSURANCE_COMPANY_RESET = "GET_INSURANCE_COMPANY_RESET"


// CREATE INSURANCE COMPANY
export const CREATE_INSURANCE_COMPANY_START = "CREATE_INSURANCE_COMPANY_START"
export const CREATE_INSURANCE_COMPANY_SUCCESS = "CREATE_INSURANCE_COMPANY_SUCCESS"
export const CREATE_INSURANCE_COMPANY_FAILED = "CREATE_INSURANCE_COMPANY_FAILED"
export const CREATE_INSURANCE_COMPANY_RESET = "CREATE_INSURANCE_COMPANY_RESET"

// UPDATE INSURANCE COMPANY
export const UPDATE_INSURANCE_COMPANY_START = "UPDATE_INSURANCE_COMPANY_START"
export const UPDATE_INSURANCE_COMPANY_SUCCESS = "UPDATE_INSURANCE_COMPANY_SUCCESS"
export const UPDATE_INSURANCE_COMPANY_FAILED = "UPDATE_INSURANCE_COMPANY_FAILED"
export const UPDATE_INSURANCE_COMPANY_RESET = "UPDATE_INSURANCE_COMPANY_RESET"


// DELETE
export const DEL_INSURANCE_COMPANY_START = "DEL_INSURANCE_COMPANY_START"
export const DEL_INSURANCE_COMPANY_SUCCESS = "DEL_INSURANCE_COMPANY_SUCCESS"
export const DEL_INSURANCE_COMPANY_FAILED = "DEL_INSURANCE_COMPANY_FAILED"
export const DEL_INSURANCE_COMPANY_RESET = "DEL_INSURANCE_COMPANY_RESET"






